var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseGreyCircleFill = function SvgCloseGreyCircleFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.513 2.487C11.19-.83 5.809-.83 2.49 2.49a8.496 8.496 0 0 0 0 12.018 8.504 8.504 0 0 0 12.023.004 8.513 8.513 0 0 0 0-12.026zm-2.68 8.337a.708.708 0 0 1-.998 1.003L8.63 9.623a.176.176 0 0 0-.251 0l-2.204 2.204a.72.72 0 0 1-1.003 0 .71.71 0 0 1 0-1.003L7.376 8.62a.174.174 0 0 0 0-.25L5.172 6.166a.708.708 0 0 1 .999-1.003l2.204 2.205c.034.033.079.052.126.052s.092-.02.125-.052l2.205-2.205a.71.71 0 1 1 1.003 1.003L9.629 8.37a.175.175 0 0 0 0 .25z"
  })));
};
export default SvgCloseGreyCircleFill;